<template>
  <div>
    <div class="course-card course-card-bg">
      <div class="title">{{detail.courseGroupName}}</div>
      <div class="tip">{{detail.subtitle}}</div>
      <div class="inline"><span style="color:#999;">时间：</span>{{detail.classTime}}</div>
      <div class="inline" v-if="teachers">
        大课授课老师：<span>{{teachers}}</span>
      </div>
    </div>
    <div class="course-card">
      <div class="title">课程内容</div>
      <div class="content" v-html="detail.richText"></div>
    </div>
  </div>
</template>

<script>
import {getCourseGroupDetail} from '@/api/api'

export default {
  data() {
    return {
      detail: {},
    }
  },
  mounted() {
    getCourseGroupDetail({id: this.$route.query.id}).then(res => {
      this.detail = res.data
    })
  },
  computed: {
    teachers() {
      return (this.detail?.teachers || []).map(i => i.teacherName).join('、')
    },
  }
}
</script>

<style lang="less" scoped>
.course-card {
  box-shadow: 0 0 4px 0 rgba(117, 117, 117, 0.25);
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  &&-bg {
    background-image: linear-gradient(to bottom, #FFF2F2, #ffffff);
  }

  > div:not(:last-child) {
    margin-bottom: 5px;
  }
  .title {
    font-size: 1.5em;
    font-weight: bold;
  }

  ::v-deep .content {
    img {
      max-width: 100%;
      height: auto;
    }

    table {
      max-width: 100%;
    }
  }
}
</style>